module.exports = "<div class=m-message v-scroll-bottom=session.messages><ul><li v-for=\"item in session.messages\"><p class=time><span>{{item.date | time}}</span></p><div class=main :class=\"{ self: item.self }\"><img class=avatar width=30 height=30 :src=\"item | avatar\"><div class=text>{{item.text}}</div></div></li></ul></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/message.vue
 ** module id = 30
 ** module chunks = 0
 **/